import React from 'react';
import { TestResult } from '../services/resultService';

interface ShowJsonResultButtonProps {
  results: TestResult;
}

const ShowJsonResultButton: React.FC<ShowJsonResultButtonProps> = ({ results }) => {
  const [show, setShow] = React.useState(false);
  if (!results) return null;
  return (
    <div className="my-4 animate-fade-in">
      <button
        className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-6 rounded-lg shadow transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-400"
        onClick={() => setShow(s => !s)}
      >
        {show ? 'Скрыть полный JSON результата' : 'Показать полный JSON результата'}
      </button>
      {show && (
        <pre className="mt-4 bg-gray-900 text-green-200 p-4 rounded-lg text-xs overflow-x-auto max-h-96 border border-gray-700 shadow-inner animate-fade-in" data-testid="json-result-block">
          {JSON.stringify(results, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default ShowJsonResultButton; 